import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export const fetchUnreadOperatorInfo = async () => {
    const res = await apiFetch(`${API_BASE}/operator-info/client/unread`);
    if (!res.ok) throw new Error("Не вдалося перевірити інформацію");
    return await res.json();
};

export const markOperatorInfoViewed = async () => {
    const res = await apiFetch(`${API_BASE}/operator-info/client/mark-viewed/operator-info`, {
        method: "PUT",
    });
    if (!res.ok) throw new Error("Не вдалося позначити інформацію як переглянуту");
    return await res.json();
};
